import { useTranslation } from 'react-i18next'

import { CoinsIcon, DotsThreeCircleVerticalIcon, PackageIcon } from '@phosphor-icons/react'

import { ButtonMenu, ComboBox, FormatPrice, IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExchangeOrderAsDraftSelector = ({
  checked,
  onChange,
  ordersWithRequestedProducts,
  requestedProducts,
  menuItems = [],
  refundQuantity,
  currency,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <Styles.ExchangeTitle>
        <Text type="titleS">{t('Nuevos productos solicitados')}:</Text>
        {menuItems?.length > 0 && (
          <ButtonMenu
            stopPropagation
            menuItems={menuItems}
            renderButton={onClick => (
              <IconButton
                variant="text"
                onClick={onClick}
                icon={<DotsThreeCircleVerticalIcon size={24} weight="light" data-testid="exchange-selector-menu" />}
              />
            )}
          />
        )}
      </Styles.ExchangeTitle>
      <>
        {ordersWithRequestedProducts > 1 && (
          <Styles.InfoContainer>
            <PackageIcon size={24} weight="light" />
            <Text type="bodyMRegular">
              {ordersWithRequestedProducts} {t('transacciones con productos solicitados por enviar')}
            </Text>
          </Styles.InfoContainer>
        )}
        {ordersWithRequestedProducts === 1 && (
          <Styles.InfoContainer>
            <PackageIcon size={24} weight="light" />
            <Text type="bodyMRegular">
              {ordersWithRequestedProducts} {t('transacción con productos solicitados por enviar')}
            </Text>
          </Styles.InfoContainer>
        )}
      </>
      <>
        {requestedProducts > 1 && (
          <Styles.InfoContainer>
            <PackageIcon size={24} weight="light" />
            <Text type="bodyMRegular">
              {requestedProducts} {t('productos solicitados por enviar')}
            </Text>
          </Styles.InfoContainer>
        )}
        {requestedProducts === 1 && (
          <Styles.InfoContainer>
            <PackageIcon size={24} weight="light" />
            <Text type="bodyMRegular">
              {requestedProducts} {t('producto solicitado por enviar')}
            </Text>
          </Styles.InfoContainer>
        )}
      </>
      {refundQuantity < 0 && (
        <Styles.RefundQuantity>
          <CoinsIcon weight="light" size={24} />
          <FormatPrice currency={currency}>{Math.abs(refundQuantity)}</FormatPrice> {t('Pago pendiente')}
        </Styles.RefundQuantity>
      )}
      <ComboBox
        fullWidth
        label={t('Gestión del pedido')}
        menuItems={[
          { label: t('Crear pedido para el envío de los nuevos productos'), value: 'issueExchangeOrderProcessing' },
          {
            label: t('Gestionar manualmente el envío de los nuevos productos'),
            value: 'notIssueExchangeOrderProcessing',
          },
        ]}
        handleChange={e => onChange(e.target.value === 'issueExchangeOrderProcessing')}
        value={checked ? 'issueExchangeOrderProcessing' : 'notIssueExchangeOrderProcessing'}
      />
    </div>
  )
}

export default ExchangeOrderAsDraftSelector
